import { ToggleTip } from '@betterment/samba-react';

export const TaxLossHarvestingToggletip = ({
  isEnabled,
  onOpenChange,
}: {
  isEnabled: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const enabledModifier = isEnabled ? '' : 'can ';
  const tooltipText = `We ${enabledModifier}actively monitor eligible accounts for opportunities to sell holdings at a loss to help reduce your taxes.`;

  return (
    <ToggleTip onOpenChange={onOpenChange}>
      <ToggleTip.Trigger label="Tax Loss Harvesting Information" css={{ ml: 'space.50', verticalAlign: 'text-top' }} />
      <ToggleTip.Content align="start" side="left" css={{ maxWidth: '300px', width: 'max-content' }}>
        {tooltipText}
      </ToggleTip.Content>
    </ToggleTip>
  );
};
